import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { PageResponse } from '@core/entities/pagination'
import {
  IOrganisationCompany,
  OrganisationCompany,
} from '@core/entities/company'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '@core/react-query/features/company/companyKeys'

const dataTransformer = (response: PageResponse<IOrganisationCompany>) => {
  return {
    ...response,
    content: response.content.map((c) => OrganisationCompany.new(c)),
  }
}

export const useOrganisationCompanies = (
  payload: RequestTypes['getCompanies'],
  options?: UseQueryOptions<
    PageResponse<IOrganisationCompany>,
    RequestErrorType,
    PageResponse<OrganisationCompany>
  >,
) => {
  return useQuery({
    keepPreviousData: true,
    select: dataTransformer,
    ...companyKeys.getCompanies(payload),
    ...options,
  })
}
